<template>
    <div component="PageError" template="page">
        <div class="bg">
            <h1>Error occured</h1>
            <p>Please contact administrator</p>
            <p v-if="error">ERROR: {{ error }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'PageError',

    computed: {
        error() {
            return this.$route.query.e;
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='PageError'] {
    .bg {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    h1 {
        width: 100%;
        text-align: center;
    }
}
</style>
